import { computed } from 'mobx'
import { type CallCenterJobSummary } from './call-center-job-summary'
import { jobStatusLabel } from './call-center-job-display'

/**
 * A job in the selected client's job history.
 */
export class CallCenterJobHistoryItemViewModel {
  constructor(
    readonly job: CallCenterJobSummary,
    private readonly _isNavigable: (job: CallCenterJobSummary) => boolean,
  ) {}

  @computed
  get statusText() {
    return jobStatusLabel(this.job.status)
  }

  @computed
  get specs() {
    return this.job.jobScopeItems.join(', ')
  }

  @computed
  get isNavigable() {
    return this._isNavigable(this.job)
  }
}
